import { Activity, GitCompareArrows, Tags } from "lucide-react";
import { GroupsEnum } from "../../../enum/groups";
import { RoleEnum } from "../../../enum/role";
import CampaignComparisonRoutes from "../../../pages/business-planning/campaign-comparison/comparison.routes";
import CampaignPropagationRoutes from "../../../pages/business-planning/campaign-propagation/propagation.routes";
import CampaignsRoutes from "../../../pages/business-planning/campaigns/campaigns.routes";

export const businessPlanningRoutes = [
  {
    id: "Gestão de Campanhas",
    category: "Campanhas",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.PLANEJAMENTO_COMERCIAL],
    path: "/gestao-campanhas/*",
    pathId: "/planejamento-comercial",
    element: <CampaignsRoutes />,
    icon: <Tags className="h-[20px] w-[20px]" />,
  },
  {
    id: "Auditoria de Propagação",
    category: "Campanhas",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.PLANEJAMENTO_COMERCIAL],
    path: "/auditoria-propagacao/*",
    pathId: "/planejamento-comercial",
    element: <CampaignPropagationRoutes />,
    icon: <Activity className="h-[20px] w-[20px]" />,
  },
  {
    id: "Comparativo Retaguarda vs Loja",
    category: "Campanhas",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.PLANEJAMENTO_COMERCIAL],
    path: "/comparativo-retaguarda/*",
    pathId: "/planejamento-comercial",
    element: <CampaignComparisonRoutes />,
    icon: <GitCompareArrows className="h-[20px] w-[20px]" />,
  },
];
